const OtherVitalInfo = () => {
    return (
        <div id="other" className="vision-card">
            <h3>OTHER VITAL INFORMATION</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <tbody>

                        <tr>
                            <th colSpan="4">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>OTHER VITAL INFORMATION</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>09308-N J MISSION SCH PO KASIA KUSHINAGAR UP</div>
                                        <div>Date: 15-12-2016</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />

                            <tr>
                                <td>10th BOARD PASS PERCENTAGE (2014/2015/2016)</td>
                                <td>100/99.48/99.14</td>
                                <td>12th BOARD PASS PERCENTAGE (2014/2015/2016)</td>
                                <td>64.79/65.25/62.26</td>
                            </tr>

                            <tr>
                                <td>NAME OF WELLNESS / ACTIVITY TEACHER</td>
                                <td>YES</td>
                                <td>NAME OF GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                                <td>Cyril Costa M</td>
                            </tr>

                            <tr>
                                <td>CONTACT NUMBER OF GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                                <td>9794190107</td>
                                <td>EMAIL ID OF GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                                <td>cyrilcosta.m@gmail.com</td>
                            </tr>

                            <tr>
                                <td>NAME OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                                <td>Sheetal Agarwal</td>
                                <td>CONTACT NUMBER OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                                <td>9984569579</td>
                            </tr>

                            <tr>
                                <td>EMAIL ID OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                                <td>sheetalagarwal998456@gmail.com</td>
                                <td>NAME OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                                <td>Cyril Costa M</td>
                            </tr>

                            <tr>
                                <td>CONTACT NUMBER OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                                <td>9794190107</td>
                                <td>EMAIL ID OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                                <td>cyrilcosta.m@gmail.com</td>
                            </tr>

                            <tr>
                                <td>TOTAL NUMBER OF DOCTORS IN SCHOOL CLINIC</td>
                                <td>0</td>
                                <td>TOTAL NUMBER OF NURSES IN SCHOOL CLINIC</td>
                                <td>0</td>
                            </tr>

                            <tr>
                                <td>TOTAL NUMBER OF BEDS IN SCHOOL CLINIC</td>
                                <td>0</td>
                                <td>LEVEL OF INVOLVEMENT OF SCHOOL IN CBSE ACTIVITIES</td>
                                <td>ACTIVE</td>
                            </tr>

                            <tr>
                                <td>DO THE TEACHERS GET PROPER GRADE LIKE PGT/TGT AS PER THE CLASSES THEY ARE ENTITLED TO TEACH?</td>
                                <td>YES</td>
                                <td>DO THE TEACHERS AND STAFF GET THEIR SALARY WITHIN FIRST WEEK OF THE MONTH?</td>
                                <td>YES</td>
                            </tr>

                            <tr>
                                <td>DOES THE SCHOOL HAS EPF FACILITY FOR STAFF</td>
                                <td>YES</td>
                                <td>EPF REGISTRATION NUMBER</td>
                                <td>UPGKP0035416000</td>
                            </tr>

                            <tr>
                                <td>MODE OF SALARY PAYMENT</td>
                                <td>bankpayment</td>
                                <td>NAME OF BANK WITH SALARY ACCOUNT</td>
                                <td>SYNDICATE BANK</td>
                            </tr>

                            <tr>
                                <td>ARE THE SCHOOL ACCOUNTS AUDITED REGULARLY?</td>
                                <td>YES</td>
                                <td>PARENT TEACHERS ASSOCIATION AS PER NORMS</td>
                                <td>YES</td>
                            </tr>

                            <tr>
                                <td>ACADEMIC SESSION</td>
                                <td>APRIL TO MARCH</td>
                                <td>VACATION PERIOD</td>
                                <td>MAY TO JUNE</td>
                            </tr>

                            <tr>
                                <td>AUDITED BALANCE SHEET OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\balance\09308.pdf)</td>
                                <td>STAFF STATEMENT OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\sta#\09308.pdf)</td>
                            </tr>

                            <tr>
                                <td>INCOME AND EXPENDITURE STATEMENT</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\income\09308.pdf)</td>
                                <td>ACADEMIC CALENDAR OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\academic\09308.pdf)</td>
                            </tr>

                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                                    BEST PRACTICES OF SCHOOL
                                </td>
                            </tr>

                            <tr>
                                <td colSpan="4">
                                    Spoken English, Teach with the help of smart class, Exhibition,
                                    Club Activities, Follow CCE, Study Tour, Sport Competition and
                                    Inter-School Competition, Class Presentations, Motivation classes,
                                    School Magazine, Campaign, Rallies, PTA Meetings.
                                </td>
                            </tr>
                        </tbody>
                </table>
            </div>

        </div>
    );
};

export default OtherVitalInfo;